import {Injectable} from '@angular/core';

import {User} from '../_models/index';

import {AuthenticationService} from './index';

import {Constants} from '../helpers/constants';
import {LoginHelper} from '../helpers';
import {of, Subject} from "rxjs";
import {map} from "rxjs/operators";
import {Load} from "../_decorators/loading.decorator";
import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import { IndexConfigService } from "./index.config.service";
import { LLMProvider } from '../_models/LLMProvider';

@Injectable()
export class UserService {
  public accountUpdated: Subject<any> = new Subject<any>();

  constructor(public http: HttpClient,
              public authenticationService: AuthenticationService,
              public config: IndexConfigService) {
  }

  getCurrent() {
    return this.getById(LoginHelper.getUserId());
  }

  getAll(tenantName: string = null) {

    const tenant = tenantName || LoginHelper.getTenantName();
    if (tenant == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<any>(this.config.api + '/api/users/all');
  }

  getActiveShort(tenantName: string = null) {

    const tenant = tenantName || LoginHelper.getTenantName();
    if (tenant == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<any>(this.config.api + '/api/users/active/short');
  }

  getAllShort(tenantName: string = null) {

    const tenant = tenantName || LoginHelper.getTenantName();
    if (tenant == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<any>(this.config.api + '/api/users/all/short');
  }

  getAllForTenant(tenantName) {
    return this.http.get<any>(this.config.api + '/api/users/all/tenant?tenantName=' + tenantName);
  }


  getManagers(tenantName: string) {
    if (!tenantName)
    {
      return of({});
    }
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<any>(this.config.api + '/api/users/managers');
  }

  getPublicManagers(tenantName: string) {
    if (!tenantName)
    {
      return of({});
    }
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<any>(this.config.api + '/api/users/managers/public');
  }

  @Load()
  updateManagers(managersInformation: any) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.post<any>(this.config.api + '/api/users/updateManagers', managersInformation)
      .pipe(map((response: any) => { this.getManagers(tenantName).subscribe(response => this.accountUpdated.next(response));}));
  }

  getByType(type: number) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<any>(this.config.api + '/api/users/type/' + type + '');
  }

  getByEmail(email: string, tenantName: string) {

    if (tenantName == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<any>(this.config.api + '/api/users/email?tenantName=' + tenantName + '&email=' + encodeURIComponent(email));
  }

  getById(id: any) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<any>(this.config.api + '/api/users/user/' + id + '');
  }

  @Load()
  create(user: User) {

    const tenantName = user.tenantName;
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.post<any>(this.config.api + '/api/users/create', user);
  }

  @Load()
  createManySurvey(users: User[], tenantName: string) {

    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.post<any>(this.config.api + '/api/users/createManySurvey', users);
  }

  @Load()
  createManyAwareness(users: User[], tenantName: string) {

    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.post<any>(this.config.api + '/api/users/createManyAwareness', users);
  }

  @Load()
  invite(user: User) {

    const tenantName = user.tenantName;
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.post<any>(this.config.api + '/api/users/invite', user);
  }

  @Load()
  update(user: User) {

    const tenantName = user.tenantName;
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.post<any>(this.config.api + '/api/users/update/' + user.userId, user);
  }

  @Load()
  changePassword(model: any) {

    const tenantName = model.tenantName;
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.post<any>(this.config.api + '/api/users/changePassword/', model);
  }

  @Load()
  updatePassword(key: string, tenantName) {

    if (tenantName == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.post<any>(this.config.api + '/api/users/updatePassword/' + key + '?tenantName=' + tenantName, {});
  }
  @Load()
  sendRestorePasswordEmail(user: User) {

    const tenantName = user.tenantName;
    if (tenantName == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.post<any>(this.config.api + '/api/users/sendupdatepasswordemail/' + user.userId, user);
  }

  @Load()
  delete(id: number) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.delete(this.config.api + '/api/users/delete/' + id);
  }

  @Load()
  unlock(id: number) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.delete(this.config.api + '/api/users/unlock/' + id);
  }

  @Load()
  setUserDisabled(id: number, disabled: boolean) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.post<any>(this.config.api + '/api/users/disabled/' + id + '/' + disabled, {});
  }

  @Load()
  generatePassword(id: number) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.post<any>(this.config.api + '/api/users/generate/' + id, {});
  }

  @Load()
  getMultilogin() {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<User[]>(this.config.api + '/api/users/multilogin');
  }

  @Load()
  setMultilogin(id: number, tenant: string, value: boolean) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.get(this.config.api + `/api/users/multilogin/${id}/${tenant}/${value}`);
  }
}
